import { useContext } from "react";
import { DIContext } from "./DIContext";
import type { AppContainer } from "./AppContainer";

export function useDI(): AppContainer {
  const ctx = useContext(DIContext);
  if (!ctx) throw new Error("useDI must be used under DIProvider");
  return ctx;
}
